// Imports
import Vue from "vue";
import Router from "vue-router";

// Middleware
import authenticate from "@/auth/authenticate";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      component: () => import("@/views/auth/Login.vue"),
    },
    {
      path: "/reset-password/:token",
      component: () => import("@/views/auth/ResetPassword.vue"),
    },
    {
      path: "/app",
      component: () => import("@/layouts/base/Index.vue"),
      beforeEnter: authenticate,
      children: [
        {
          path: "",
          name: "Home",
          component: () => import("@/views/home/Home.vue"),
        },
        {
          path: "clients",
          name: "store.clients",
          component: () => import("@/views/store/ClientManagement.vue"),
        },
        {
          path: "init/:id",
          name: "init-store",
          component: () => import("@/views/home/Init.vue"),
        },
        {
          path: ":id",
          name: "store.index",
          component: () => import("@/views/home/Index.vue"),
        },
        {
          path: ":id/logs",
          name: "store.logs",
          component: () => import("@/views/home/Logs.vue"),
        },
      ],
    },
    {
      path: "/admin",
      component: () => import("@/layouts/base/Index.vue"),
      beforeEnter: authenticate,
      children: [
        {
          path: "",
          name: "admin",
          component: () => import("@/views/admin/Admin.vue"),
          meta: { isAdmin: true },
        },
      ],
    },
  ],
});

export default router;
